<template>
  <div class="main-wrapper" v-if="valueData">
    <div id="typprijmu" class="questionare-text bold">{{ parsedType }}</div>
    <div id="sumaprijmu" class="questionare-text bold">+ {{ valueData.toLocaleString() }} EUR</div>
    <div class="controls">
      <div v-if="type !== 'materska_rodicovsky_prispevok'" :id="id" @click="$emit('update', id)">UPRAVIŤ</div>
      <div :id="id" @click="$emit('delete', id)">ZMAZAŤ</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IncomeItem",
  props: {
    type: String,
    value: Number,
    id: [Number, Array],
    diets: [Object, null]
  },
  data: () => ({
    parsedType: "",
    valueData: null
  }),
  created() {
    this.valueData = this.value;

    this.parseType();
  },
  updated() {
    this.parseType();
  },
  methods: {
    parseType() {
      switch (this.type) {
        case "trvaly_pracovny_pomer":
          this.parsedType = "Zamestnanie";
          break;
        case "prijem_zivnostnika":
          this.parsedType = "SZČO";
          break;
        case "prijem_z_sro":
          this.parsedType = "Príjem z sro";
          break;
        case "prijem_z_prenajmu_nehnutelnosti":
          this.parsedType = "Prenájom"
          break;
        case "dochodca":
          this.parsedType = "Dôchodok";
          break;
        case "materska_rodicovsky_prispevok":
          this.parsedType = "Rodičovský príspevok"
          break;
      }
    }
  },
  watch: {
    diets(to) {
      if (to) {
        switch (to.frequency) {
          case "monthly":
            this.valueData += to.value;
            break;
          case "quaterly":
            this.valueData += to.value / 3;
            break;
          case "semiannualy":
            this.valueData += to.value / 6;
            break;
          case "annualy":
            this.valueData += to.value / 12;
            break;
        }
      }
    },
    value(to) {
      this.valueData = to
    }
  }
}
</script>

<style lang="scss" scoped>

</style>